import React, { useEffect, useState } from "react";
import { Container, Card } from "react-bootstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { db } from "../firebase/firebase-config";
import { collection, getDocs } from "firebase/firestore/lite";

const MembershipPage = () => {
  const [eligibility, setEligibility] = useState([]);
  const [conditions, setConditions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchMembershipData();
  }, []);

  async function fetchMembershipData() {
    try {
      setLoading(true);
    
      const eligibilityRef = collection(db, "sacco", "TEKiK01inpRB3NFlK65S", "eligibility");
      const conditionsRef = collection(db, "sacco", "TEKiK01inpRB3NFlK65S", "conditions");

      const eligibilitySnapshot = await getDocs(eligibilityRef);
      const conditionsSnapshot = await getDocs(conditionsRef);

      setEligibility(eligibilitySnapshot.docs.map((doc) => doc.data().text));
      setConditions(conditionsSnapshot.docs.map((doc) => doc.data().text));
    } catch (err) {
      console.error("Error fetching membership data:", err);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <Navbar />
      <Container className="membership-container">
        <div className="container mx-auto px-4 py-12">
          <h2 className="text-2xl font-bold text-gray-800 text-center mb-6">
            Membership Eligibility and Conditions
          </h2>

          {loading ? (
            <div>Loading...</div>
          ) : (
            <div className="grid md:grid-cols-2 gap-8">
              {/* Eligibility Section */}
              <div className="bg-white p-6 shadow-lg rounded-lg">
                <h3 className="text-green-600 font-bold text-xl mb-4">Eligibility Criteria:</h3>
                <ul className="text-gray-700 list-disc list-inside space-y-2">
                  {eligibility.map((criteria, index) => (
                    <li key={index}>{criteria}</li>
                  ))}
                </ul>
              </div>

              {/* Membership Conditions Section */}
              <div className="bg-white p-6 shadow-lg rounded-lg">
                <h3 className="text-blue-600 font-bold text-xl mb-4">Membership Conditions:</h3>
                <ul className="text-gray-700 list-disc list-inside space-y-2">
                  {conditions.map((condition, index) => (
                    <li key={index}>{condition}</li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </div>
      </Container>
      <Footer />
    </>
  );
};

export default MembershipPage;
